import reduce from 'lodash/fp/reduce'


const fields = {
    LOGIN: 'login',
    PASSWORD: 'password',
    REMEMBER_ME: 'rememberMe'
}

export const initialValues = reduce((acc, field) => ({
    ...acc,
    login: '',
    password: '',
    rememberMe: false
}), {}, Object.values(fields))

export default fields
